import { render, staticRenderFns } from "./TableCurrentPlanWithSubscription.vue?vue&type=template&id=2cf4fe21&scoped=true"
import script from "./TableCurrentPlanWithSubscription.vue?vue&type=script&lang=js"
export * from "./TableCurrentPlanWithSubscription.vue?vue&type=script&lang=js"
import style0 from "./TableCurrentPlanWithSubscription.vue?vue&type=style&index=0&id=2cf4fe21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf4fe21",
  null
  
)

export default component.exports